import type { LangCode, VoucherI18n_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { FeatureIslandContainer, FeatureIslandHeader } from "@/components/features/_layouts";

import { HeaderUpdateButton } from "./components/header/update-button/update-button";
import { MarketingExistingVoucherI18nFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { VoucherI18nFormMain } from "../_components/root";

type Props = {
	serverModel: VoucherI18n_EditPageQuery;
	activeLangCode?: LangCode;

	navigator?: {
		default: string;
		i18n: (langCode: LangCode) => string;
	};
};

export const VoucherI18nEditPresenter = ({ serverModel, navigator, activeLangCode }: Props) => {
	const init = useInitialized({ serverModel });
	const { isDirty } = init.viewModel;

	useTransitionBlock(isDirty);

	return (
		<MarketingExistingVoucherI18nFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="宿泊券の編集"
					navigator={navigator}
					activeLangCode={activeLangCode}
					rightChildren={<HeaderUpdateButton />}
				/>
				<VoucherI18nFormMain />
			</FeatureIslandContainer>
		</MarketingExistingVoucherI18nFormModelContextProvider>
	);
};

VoucherI18nEditPresenter.displayName = "VoucherI18nEditPresenter";
